import Navbar from "@/pages/home/components/Navbar";
import TickerBar from "@/pages/home/components/TickerBar";
import Hero from "@/pages/home/components/Hero";
import Feed from "@/pages/home/components/Feed";
import HotRanking from "@/pages/home/components/HotRanking";
import TrendingTopics from "@/pages/home/components/TrendingTopics";
import Special from "@/pages/home/components/Special";
import About from "@/pages/home/components/About";
import Faq from "@/pages/home/components/Faq";
import Subscribe from "@/pages/home/components/Subscribe";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";
import { faqList, feedItems } from "@/mocks/news";

function StructuredData() {
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };

  const collectionData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "吃瓜51 新瓜速递",
    url: "https://xmmyx.cn/",
    inLanguage: "zh-CN",
    hasPart: feedItems.map((f) => ({
      "@type": "Article",
      headline: f.title,
      description: f.summary,
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqData) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionData) }} />
    </>
  );
}

export default function Home() {
  return (
    <>
      <StructuredData />
      <div className="min-h-screen w-full bg-background-50">
        <TickerBar />
        <Navbar />
        <main>
          <Hero />
          <HotRanking />
          <Feed />
          <TrendingTopics />
          <Special />
          <About />
          <Faq />
          <Subscribe />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </>
  );
}